import { CoordinatesData } from "../../../../models/address-suggestions/coordinate-data.model";
import { CoordinatesDataDTO } from "../dtos/coordinates-data.api.dto";

export const coordinatesDataMapper = (response: CoordinatesDataDTO): CoordinatesData => {
  return {
    latitude: response.latitude,
    longitude: response.longitude,
  };
};
